import MDButton from "components/MDButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useEffect, useState } from "react";
import MDModal from "components/MDModal";
import MDInput from "components/MDInput";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const PlansModal = (props) => {
  const Service = useAppServices();
  const { app_id } = useParams();
  const [openAddProduct, setOpenAddProduct] = useState(false);

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false);
    const [features, setFeatures] = useState([""]); // Initialize with one empty feature

    const handleAddFeature = () => {
      setFeatures([...features, ""]);
    };

    const handleRemoveFeature = (index) => {
      if (features.length > 1) {
        const updatedFeatures = [...features];
        updatedFeatures.splice(index, 1);
        setFeatures(updatedFeatures);
      }
    };

    const handleFeatureChange = (index, value) => {
      const updatedFeatures = [...features];
      updatedFeatures[index] = value;
      setFeatures(updatedFeatures);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setProcessing(true);

      let plans = props.plans || [];
      const plan = {
        name: e.target.name.value,
        plan_id: e.target.plan_id.value,
        price: e.target.price.value,
        description: e.target.description.value,
        features: features.filter(f => f.trim() !== ""), // Filter out empty features
      };

      plans.push(plan);
      const payload = {
        plans: plans,
        _id: app_id,
      };

      const { response } = await Service.app.update({ payload });
      if (response) {
        setOpenAddProduct(false);
        setProcessing(false);
        setFeatures([""]); // Reset features
        props.handleChange();
      } else {
        setProcessing(false);
      }
    };

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      maxHeight: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    };

    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox>
          <MDTypography component="h1" mb={3} variant="h5">
            Add New Plan
          </MDTypography>

          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
          >
            <Grid container spacing={2}>
              <Grid item md={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Plan Name
                  </MDTypography>
                  <MDInput
                    required
                    id="bootstrap-input"
                    fullWidth
                    placeholder="Plan Name"
                    name="name"
                  />
                </MDBox>
              </Grid>

              <Grid item md={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Plan ID
                  </MDTypography>
                  <MDInput
                    required
                    id="bootstrap-input"
                    fullWidth
                    placeholder="Plan ID"
                    name="plan_id"
                  />
                </MDBox>
              </Grid>

              <Grid item md={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Plan Price
                  </MDTypography>
                  <MDInput
                    required
                    type="number"
                    fullWidth
                    placeholder="Plan Price"
                    name="price"
                    inputProps={{ step: "0.01" }}
                  />
                </MDBox>
              </Grid>

              <Grid item md={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Description
                  </MDTypography>
                  <MDInput
                    multiline
                    rows={3}
                    fullWidth
                    placeholder="Plan Description"
                    name="description"
                  />
                </MDBox>
              </Grid>

              <Grid item md={12}>
                <MDBox mb={1}>
                  <MDTypography variant="button" display="block" gutterBottom>
                    Features
                  </MDTypography>
                  {features.map((feature, index) => (
                    <MDBox key={index} display="flex" alignItems="center" mb={1}>
                      <MDInput
                        fullWidth
                        value={feature}
                        onChange={(e) => handleFeatureChange(index, e.target.value)}
                        placeholder={`Feature ${index + 1}`}
                      />
                      <IconButton onClick={() => handleRemoveFeature(index)} disabled={features.length <= 1}>
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                      {index === features.length - 1 && (
                        <IconButton onClick={handleAddFeature}>
                          <AddCircleOutlineIcon />
                        </IconButton>
                      )}
                    </MDBox>
                  ))}
                </MDBox>
              </Grid>
            </Grid>

            <MDBox>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                disabled={processing}
                loading={processing}
                sx={{ mt: 4, mb: 1 }}
                fullWidth
              >
                Add Plan
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    );
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false);
  };

  return (
    <>
      <MDButton
        sx={{ marginLeft: 3 }}
        variant="outlined"
        color="info"
        startIcon={<AddBoxIcon />}
        onClick={() => setOpenAddProduct(true)}
      >
        Add Plan
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  );
};

export default PlansModal;